
// base stuff
import { Component, Vue } from "vue-property-decorator"
// apollo queries
import MessagesQuery from "../../graphql/messages/messages.graphql"
import UpdateLastReadMessage from "../../graphql/messages/updateLastReadMessage.graphql"
import CountUnreadMessages from "../../graphql/messages/countUnreadMessages.graphql"

import { CircularLoader, PullRefresh } from "@coredination/components"

@Component({
    apollo: {
        messages: {
            query: MessagesQuery,
            pollInterval: 30000,
            variables() {
                return {
                    limit: this.limit,
                    //offset: this.offset
                    //from: null,
                    //to: null
                }
            },
        },
        countUnreadMessages: {
            query: CountUnreadMessages,
            pollInterval: 30000,
        },
    },
    components: {
        CircularLoader,
        PullRefresh,
    },
})
export default class NotificationsView extends Vue {
    messages?: any
    countUnreadMessages?: any
    limit = 10
    offset = 0

    markAllAsRead() {
        this.$apollo
            .mutate({
                mutation: UpdateLastReadMessage,
                variables: { date: Date() },
                update(proxy, response) {
                    // console.log(proxy, response)
                },
            })
            .then((response) => {
                this.refresh()
            })
            .catch((error) => {
                console.error(error)
            })
    }
    mounted() {
        this.markAllAsRead()
    }
    routeFromMessage(message: any) {
        if (!message.attachments || !message.attachments.length) return
        const type = message.attachments[0].type
        const id = message.attachments[0].referenceUuid
        return `/${type}/${id}`
    }

    capitalize(string: string) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase()
    }
    trimContent(content: string) {
        return content
            .replaceAll(/(<br([^>]+)>)/gi, " ")
            .replaceAll("\\s+", " ")
            .trim()
    }
    extendLimit() {
        this.limit += 10
        this.refresh()
    }
    refresh() {
        if (this.$apollo.queries.messages && typeof this.$apollo.queries.messages.refetch == "function")
            this.$apollo.queries.messages.refetch()
        if (
            this.$apollo.queries.countUnreadMessages &&
            typeof this.$apollo.queries.countUnreadMessages.refetch == "function"
        )
            this.$apollo.queries.countUnreadMessages.refetch()
    }
    get messageGroups() {
        if (!this.messages) return []
        const messageGroups = this.messages.reduce((messageGroups: any, message: any) => {
            const date = message.date.split("T")[0]
            if (!messageGroups[date]) {
                messageGroups[date] = []
            }
            messageGroups[date].push(message)
            return messageGroups
        }, {})

        const groupArrays = Object.keys(messageGroups).map((date) => {
            return {
                date,
                messages: messageGroups[date],
            }
        })
        return groupArrays
    }
}
